import Config from '../Config';
import { RestService } from './RestService';

export const OrganisationService = {
    getOrganisationDetails: async function() {
        return RestService.get(`${Config.get_organisation_details}`, {})
        .then(response => response.json());
    },
    updateOrganisationInformation: async function(body){
        return RestService.post(`${Config.update_organisation_information}`, {}, body)
        .then((response) => response.json());
    },
    resetInvoiceNo: async function(body){
        return RestService.post(`${Config.reset_invoice_no}`, {}, body)
        .then((response) => response.json());
    },
    resetPaymentNo: async function(body){
        return RestService.post(`${Config.reset_payment_no}`, {}, body)
        .then((response) => response.json());
    },
    resetCreditNoteNo: async function(body){
        return RestService.post(`${Config.reset_credit_note_no}`, {}, body)
        .then((response) => response.json());
    },
    enableAutoScheduling: async function(headers, body){
        return RestService.post(`${Config.enable_auto_scheduling}`, headers, body)
        .then((response) => response.json());
    },
    enableDueCheck: async function(headers, body){
        return RestService.post(`${Config.enable_due_check}`, headers, body)
        .then((response) => response.json());
    }
};